// frontend/src/pages/AdminPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminFilmographyTab from './admin/AdminFilmographyTab';
import AdminNoticeTab from './admin/AdminNoticeTab';
import AdminNewsTab from './admin/AdminNewsTab';
import AdminUsersTab from './admin/AdminUsersTab';
import AdminGalleryTab from './admin/AdminGalleryTab';
import AdminPopupTab from './admin/AdminPopupTab';
import "../styles/Admin.css";

import { LuActivity } from "react-icons/lu";

export default function AdminPage({ user }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState('filmography');

  // 관리자 권한 체크
  if (!user || user.role !== "admin") {
    return (
      <div className="sub-page-container admin-page">
        <header className="admin-header">
          <h2 className="admin-title">RESTRICTED</h2>
          <p className="auth-error">관리자 전용 페이지입니다.</p>
        </header>
      </div>
    );
  }

  return (
    <div className="sub-page-container admin-page">
      <div className="admin-inner">
        {/* 상단 헤더 섹션 */}
        <header className="admin-header">
          <div className="header-left">
            <button onClick={() => navigate('/admin/analysis')} className="admin-btn-h primary small">
              <LuActivity className="icon-pulse" />
            </button>
          </div>
          <div className="header-right user-badge">
            <span className="user-id">{user?.id}</span>
            <span className="user-role">{user?.role}</span>
          </div>
        </header>

        {/* 세련된 탭 네비게이션 */}
        <nav className="admin-tab-nav">
          {[
            { id: 'filmography', label: 'FILMOGRAPHY' },
            { id: 'gallery', label: 'GALLERY' },
            { id: 'news', label: 'NEWS' },
            { id: 'notice', label: 'NOTICE' },
            { id: 'popup', label: 'POPUP' },
            { id: 'users', label: 'USERS' }
          ].map((item) => (
            <button 
              key={item.id}
              type="button" 
              onClick={() => setTab(item.id)} 
              className="admin-tab-btn" 
              data-active={tab === item.id}
            >
              {item.label}
              {tab === item.id && <span className="active-bar" />}
            </button>
          ))}
        </nav>

        {/* 각 탭 패널 컨텐츠 */}
        <main className="admin-tab-content">
          <section className="tab-panel-wrapper">
            {tab === 'filmography' && <AdminFilmographyTab />}
            {tab === 'gallery' && <AdminGalleryTab />}
            {tab === 'news' && <AdminNewsTab />}
            {tab === 'notice' && <AdminNoticeTab />}
            {tab === 'popup' && <AdminPopupTab />}
            {tab === 'users' && <AdminUsersTab />}
          </section>
        </main>
      </div>
    </div>
  );
}